import api, { ApiResponse } from './api';

export interface NoteVersion {
  notes: string | null;
  at: string | null;
  author: string | null;
  source: string | null;
  client?: string | null;
  kind?: 'before' | 'unrecorded';
}

/** entity: offer, flow, network, traffic-source, landing-page or rule-group. */
export const notesHistory = async (entity: string, id: string): Promise<NoteVersion[]> =>
  (await api.get<ApiResponse<NoteVersion[]>>(`/notes-history/${entity}/${id}`)).data.data!;
